import { render, staticRenderFns } from "./TechResultList.vue?vue&type=template&id=25dd461c&scoped=true"
import script from "./TechResultList.vue?vue&type=script&lang=js"
export * from "./TechResultList.vue?vue&type=script&lang=js"
import style0 from "./TechResultList.vue?vue&type=style&index=0&id=25dd461c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd461c",
  null
  
)

export default component.exports